<template>
  <AcademyLayout>
    <main class="main-content">
      <div class="courses-container">

        <!-- Cursos Free -->
        <div v-if="freeCourses.length || isLoading">
          <h2 class="courses-title p-0">{{$t('academy.free-courses')}}</h2>
          <div v-if="isLoading" class="text-center mb-3">
            <b-spinner label="Cargando..."></b-spinner>
          </div>
          <CoursesGrid v-if="freeCourses.length && !isLoading" :courses="freeCourses" context="academy" />
        </div>
        
        <!-- Cursos Premium -->
        <div v-if="premiumCourses.length || isLoading" class="mt-5">
          <h2 class="courses-title p-0">{{$t('academy.premium-courses')}}</h2>
          <div v-if="isLoading" class="text-center mb-3">
            <b-spinner label="Cargando..."></b-spinner>
          </div>
          <CoursesGrid v-if="premiumCourses.length && !isLoading" :courses="premiumCourses" context="academy" />
        </div>
      </div>
    </main>
  </AcademyLayout>
</template>

<script>
import AcademyLayout from '@/layouts/AcademyLayout.vue';
import CoursesGrid from "@/components/academy/CoursesGrid.vue";
import academyData from '@/data/academyData';

export default {
  components: {
    AcademyLayout,
    CoursesGrid
  },
  data() {
    return {
      courses: [],
      isLoading: true
    };
  },
  computed: {
    freeCourses() {
      return this.courses.filter(course => 
        course.modality === 'free' && course.isPublished === true
      );
    },
    premiumCourses() {
      return this.courses.filter(course => 
        course.modality === 'premium' && course.isPublished === true
      );
    }
  },
  async mounted() {
    try {
      // Solo traerá cursos con isPublished: true
      this.courses = await academyData.getCourses();
      
      console.log(`Cursos publicados cargados en Academia: ${this.courses.length}`);
    } catch (error) {
      console.error('Error al cargar cursos publicados:', error);
      this.courses = [];
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>
.academy-layout {
  display: flex;
  min-height: 100vh;
}
.sidebar {
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  height: 100vh;
}
.main-content { 
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #ddd;
  border-top-color: #4b48cb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>